import { render } from "./detail-estimation.vue?vue&type=template&id=7325db6a&scoped=true&ts=true"
import script from "./detail-estimation.vue?vue&type=script&lang=ts"
export * from "./detail-estimation.vue?vue&type=script&lang=ts"

import "./detail-estimation.vue?vue&type=style&index=0&id=7325db6a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7325db6a"]])

export default __exports__